// extracted by mini-css-extract-plugin
export default {"switch":"SwitchActions_switch__YWab9","switchItem":"SwitchActions_switchItem__zM8Gi","switchActive":"SwitchActions_switchActive__Znn7g"};